import { get } from ".";

export function poll(id: number) {
  return get(`APIJob/Result/${id}`, {});
}
